const TRIAL_PROGRAM_IDS = [24, 29];

export const isTrialUser = userClaims =>
  TRIAL_PROGRAM_IDS.includes(userClaims?.program_id);

// We let the user place an order if they have ANY active download plans w. quota
// It is up to Orders to do in depth checks for matching plans
export const userCanDownload = (user, subscriptions) => {
  // Do not check download quota for non-trial users
  // Not all download quota sources are reflected in AdminNG today
  // See: WEBAPPS-2291
  if (!isTrialUser(user)) {
    return true;
  }

  return subscriptions?.some(subscription => {
    const downloadQuotaEnabled =
      subscription.quota_enabled && subscription.quota_sqkm > 0;
    const hasQuotaLeft = subscription.quota_sqkm - subscription.quota_used > 0;

    return downloadQuotaEnabled && hasQuotaLeft;
  });
};
